import { apiRequest } from "./queryClient";
import { RecipeService } from "@/lib/recipeService";
import { CollectionService } from "@/lib/collectionService";

const DIGEST_STORAGE_KEY = "bp-digest";

export interface SpaceDigest {
  lastRecipeUpdatedAt: string | null;
  lastCollectionUpdatedAt: string | null;
}

export async function fetchDigest(): Promise<SpaceDigest> {
  const res = await apiRequest("GET", "/recipes/digest");
  return res.json();
}

export function getStoredDigest(): SpaceDigest | null {
  try {
    const raw = localStorage.getItem(DIGEST_STORAGE_KEY);
    return raw ? (JSON.parse(raw) as SpaceDigest) : null;
  } catch {
    return null;
  }
}

export function storeDigest(digest: SpaceDigest): void {
  localStorage.setItem(DIGEST_STORAGE_KEY, JSON.stringify(digest));
}

export function clearStoredDigest(): void {
  localStorage.removeItem(DIGEST_STORAGE_KEY);
}

// Check the digest and refresh only what changed.
// Safe to call when offline — errors are silently swallowed.
export async function checkAndInvalidate(): Promise<void> {
  try {
    const digest = await fetchDigest();
    const stored = getStoredDigest();

    const recipesChanged =
      !stored || digest.lastRecipeUpdatedAt !== stored.lastRecipeUpdatedAt;
    const collectionsChanged =
      !stored || digest.lastCollectionUpdatedAt !== stored.lastCollectionUpdatedAt;

    if (recipesChanged) {
      await RecipeService.load();
    }

    if (collectionsChanged) {
      await CollectionService.load();
    }

    storeDigest(digest);
  } catch {
    // Offline or auth error — leave store as-is
  }
}
